if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        
        this.form = this.querySelector('form');

        // Listen for variant changes to update bundle SKU (dataLayer) 
        document.addEventListener('variant:change', this.getBundleTrackingData.bind(this));

        if (this.form) {
          const idEl = this.form.querySelector('[name=id]');
          if (idEl) idEl.disabled = false;
          
          // manipulate id name for upsell
          this.form.querySelector('input[name=id].product-variant-id')?.setAttribute('name', 'items[0][id]');
          this.form.querySelector('select[name=id].product-variant-id')?.setAttribute('name', 'items[0][id]');
          
          this.errorWrapper = this.form.querySelector('[js-pdp-form-error] ul');
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        document.addEventListener('selectPDPOptions:change', this.getSelectionOption.bind(this));

        document.addEventListener('nativePropertySelectOptionDrop:init', this.nativeSelectOptionDrop.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      
      getBundleTrackingData() {
        if (!window.kalkiBundle || !window.kalkiBundle.product_is_bundle) {
          return null;
        }

        return {
          event: "add_to_cart_bundle",
          product_is_bundle: true,
          bundle_collection: window.kalkiBundle.bundle_collection,
          bundle_id: window.kalkiBundle.bundle_id,
          bundle_name: window.kalkiBundle.bundle_name,

          ecommerce: {
            currency: window.kalkiBundle.currency,
            value: window.kalkiBundle.bundle_price,

            items: [
              {
                item_id: window.kalkiBundle.bundle_id,
                item_name: window.kalkiBundle.bundle_name,
                item_category: "Couple Edit",
                quantity: 1,
                price: window.kalkiBundle.bundle_price
              }
            ]
          }
        };
      }

      pushBundleAddToCartEvent() {
        if (!window.kalkiBundle || !window.kalkiBundle.product_is_bundle) return;

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: "add_to_cart_bundle",
          product_is_bundle: true,
          bundle_collection: window.kalkiBundle.bundle_collection,
          bundle_id: window.kalkiBundle.bundle_id,
          bundle_name: window.kalkiBundle.bundle_name,

          ecommerce: {
            currency: window.kalkiBundle.currency,
            value: window.kalkiBundle.bundle_price,
            items: [
              {
                item_id: window.kalkiBundle.bundle_id,
                item_name: window.kalkiBundle.bundle_name,
                item_category: "Couple Edit",
                quantity: 1,
                price: window.kalkiBundle.bundle_price
              }
            ]
          }
        });

        console.log("add_to_cart_bundle pushed to dataLayer");
      }

      setupCloudflareHandler() {
        const originalFetch = window.fetch;
        
        window.fetch = function(...args) {
          return originalFetch.apply(this, args).then(async response => {
            if (!args[0].includes('/cart/')) {
              return response;
            }

            if (response.status === 429) {
              const text = await response.clone().text();
              
              if (text.includes('<!DOCTYPE html>') || text.includes('__cf_chl')) {
                const returnUrl = window.location.href;
                sessionStorage.setItem('return_to_product', returnUrl);
                sessionStorage.setItem('captcha_challenge_detected', 'true');
                
                showCloudflareNotification('🔒 Security verification required. Redirecting...', 'warning');
                
                setTimeout(() => {
                  window.location.href = '/cart';
                }, 500);
                
                return Promise.reject(new Error('Cloudflare challenge - redirecting'));
              }
            }

            return response;
          }).catch(error => {
            console.error('Fetch error:', error);
            throw error;
          });
        }.bind(this);
      }

      nativeSelectOptionDrop({detail}) {
        const context_ = detail;

        let optionName = context_.dataset.optionName;
        let isRequired = context_.getAttribute('required') != null;
        let optionValue= context_.value;

        let errAlreadyThere = this.errorWrapper?.querySelector(`li[data-option-name="${optionName}"]`);
        if (errAlreadyThere && optionValue) {
          this.errorWrapper.removeChild(errAlreadyThere);
        }

        if (this.errorWrapper) {
          this.errorWrapper.style.display = 'none';
          if (this.errorWrapper?.childElementCount) {
            this.errorWrapper.style.display = 'block';
          }
        }
      }

      getSelectionOption({ detail }) {
        const context_ = detail.context;

        let optionName = context_.dataset.optionName;
        let isRequired = context_.getAttribute('required') != null;
        let optionValue= context_.value;

        let errAlreadyThere = this.errorWrapper?.querySelector(`li[data-option-name="${optionName}"]`);
        if (errAlreadyThere && optionValue) {
          this.errorWrapper.removeChild(errAlreadyThere);
        }
        if (this.errorWrapper) {
          this.errorWrapper.style.display = 'none';
        }
        if (this.errorWrapper?.childElementCount) {
          this.errorWrapper.style.display = 'block';
        }
      }

      formValidation() {
        this.errorWrapper.style.display = 'none';
        let requiredOptionSelects = this.form.querySelectorAll('[js-custom-option-select][required]');

        if (requiredOptionSelects) {
          requiredOptionSelects.forEach(el => {
            const optionName = el?.dataset.optionName;
            let errAlreadyThere = this.errorWrapper?.querySelector(`li[data-option-name="${optionName}"]`);
            if (el.value == '' && !errAlreadyThere) {
              let newError = document.createElement('li');
              newError.setAttribute('data-option-name', optionName);
              newError.textContent = `Please select ${optionName}`;
              this.errorWrapper?.appendChild(newError);
            }
          });
        }
      }

      extractFormProperties(form) {
        const props = {};
        const upsellInputs = form.querySelectorAll('[js-upsell-product] input');
        const upsellNames = new Set();
        upsellInputs.forEach(el => {
          if (el.name) upsellNames.add(el.name);
        });

        const formData = new FormData(form);
        for (const [key, value] of formData.entries()) {
          if (!value || typeof value !== 'string' || !value.trim()) continue;
          if (key === 'id' || key === 'quantity' || key === 'form_type' || key === 'utf8') continue;
          if (key === 'items[0][id]' || key === 'items[0][quantity]') continue;
          if (key === 'sections' || key === 'sections_url') continue;
          if (upsellNames.has(key)) continue;

          let propName = null;
          let m = key.match(/^properties\[([^\]]+)\]$/);
          if (m) {
            propName = m[1];
          } else {
            m = key.match(/^items\[0\]\[properties\]\[([^\]]+)\]$/);
            if (m) {
              propName = m[1];
            } else {
              m = key.match(/^items\[0\]\[properties\[([^\]]+)\]\]?$/);
              if (m) {
                propName = m[1];
              }
            }
          }

          if (propName) {
            if (propName === '_ref_id' || propName === '_with_upsell' || propName === '_type') continue;
            props[propName] = value.trim();
          }
        }
        return props;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.isSubmitting) return;
        const twiningProduct = this.form.querySelector('.twining-tab-warp');
        if (twiningProduct) {
          // Couple/twining sets are added by twining-product.js (female + male
          // variant IDs come from the size labels, not this form's hidden ids).
          return;
        }
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.isSubmitting = true;
      
        this.handleErrorMessage();
      
        // Start showing loader immediately
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');
      
        const refTimeStamp = Date.now();
        window.upsellRefTimeStamp = refTimeStamp;
        this.setupCloudflareHandler();

        try {
          const rawFormData = new FormData(this.form);
          const variantId = rawFormData.get('items[0][id]') || rawFormData.get('id') || this.form.querySelector('[name="items[0][id]"]')?.value || this.form.querySelector('[name="id"]')?.value;
          const quantity = rawFormData.get('items[0][quantity]') || rawFormData.get('quantity') || 1;

          if (!variantId) {
            throw new Error('Please select an option');
          }

          const upsellProducts = this.form.querySelectorAll('[js-upsell-product] input:checked');
          const hasUpsells = upsellProducts.length > 0;

          const mainProperties = this.extractFormProperties(this.form);
          if (hasUpsells) {
            mainProperties['_ref_id'] = String(refTimeStamp);
            mainProperties['_with_upsell'] = 'Yes';
            mainProperties['_type'] = 'main product';
          }

          const submitFormData = new FormData();
          let itemIndex = 0;

          // 1. Add upsell products first so the main product appears at the top of the cart drawer
          if (hasUpsells) {
            upsellProducts.forEach((elm) => {
              const prodId = elm.dataset.productId || elm.value;
              if (prodId && !isNaN(Number(prodId)) && Number(prodId) > 0) {
                submitFormData.append(`items[${itemIndex}][id]`, Number(prodId));
                submitFormData.append(`items[${itemIndex}][quantity]`, 1);
                submitFormData.append(`items[${itemIndex}][properties][_ref_id]`, String(refTimeStamp));
                submitFormData.append(`items[${itemIndex}][properties][_type]`, 'sub product');
                itemIndex++;
              }
            });
          }

          // 2. Add main product
          submitFormData.append(`items[${itemIndex}][id]`, Number(variantId));
          submitFormData.append(`items[${itemIndex}][quantity]`, Number(quantity));
          for (const [pKey, pVal] of Object.entries(mainProperties)) {
            submitFormData.append(`items[${itemIndex}][properties][${pKey}]`, pVal);
          }

          if (this.cart) {
            submitFormData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            submitFormData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = submitFormData;

          const response = await fetch(`${routes.cart_add_url}`, config).then((r) => r.json());

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          });

          const quickAddModal = this.closest('quick-add-modal');
          const shirtPdpPopup = this.closest('[js-shirt-pdp-popup]');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                  if (typeof updateCartEstimatedDelivery === 'function') {
                    updateCartEstimatedDelivery();
                  }
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            if (typeof updateCartEstimatedDelivery === 'function') {
              updateCartEstimatedDelivery();
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (shirtPdpPopup) {
              shirtPdpPopup.dispatchEvent(new CustomEvent('shirt-pdp-popup:close', { bubbles: true }));
            }
          }

          const customizePopup = document.getElementById('size-customize-popup');
          const customizeBody = document.body;
          if (customizePopup && customizePopup.classList.contains("customize-popup-open")) {
            customizePopup.classList.remove("customize-popup-open");
            customizeBody.classList.remove("customize-open");
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          this.handleErrorMessage(error && error.message ? error.message : 'Error adding to cart');
        } finally {
          this.hideLoader();
        }
      }
      
      hideLoader() {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner')?.classList.add('hidden');
        setTimeout(() => {
          this.isSubmitting = false;
        }, 1000);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.setAttribute('tabindex', '-1');
          const buyNowButtons = document.querySelectorAll("button[type=\"button\"].shopify-payment-button__button.shopify-payment-button__button--unbranded");

          setTimeout(() => {
            requestAnimationFrame(() => {
              this.errorMessageWrapper.focus();
              buyNowButtons?.forEach((button) => {
                  button?.removeAttribute('disabled');
              });
            });
          }, 200);
          this.hideLoader();
        }
      }
    }
  );
}

// Handle cart page redirect after CAPTCHA
function handleCartPageAfterCaptcha() {
  const returnUrl = sessionStorage.getItem('return_to_product');
  const captchaDetected = sessionStorage.getItem('captcha_challenge_detected');
  
  if (!returnUrl || !captchaDetected) {
    return;
  }
  
  if (window.location.pathname !== '/cart') {
    return;
  }
  
  showCartMessage(returnUrl);
}

function showCartMessage(returnUrl) {
  const container = document.createElement('div');
  container.setAttribute('data-captcha-handler', 'true');
  container.style.cssText = `position: fixed;bottom: 30px;right: 30px;background: white;border: 2px solid #28a745;border-radius: 8px;padding: 20px;max-width: 350px;z-index: 99999;box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;  `;
  
  const title = document.createElement('h3');
  title.textContent = '✅ Ready to Continue';
  title.style.cssText = `margin: 0 0 10px 0;font-size: 16px;color: #28a745;font-weight: 600;  `;
  container.appendChild(title);
  
  const message = document.createElement('p');
  message.textContent = 'Security verification complete. Click below to return and add the product to your cart.';
  message.style.cssText = `margin: 0 0 15px 0;font-size: 14px;color: #333;line-height: 1.5;  `;
  container.appendChild(message);
  
  const button = document.createElement('button');
  button.textContent = '← Return to Product';
  button.style.cssText = `width: 100%;padding: 12px 16px;background: #28a745;color: white;border: none;border-radius: 6px;font-size: 14px;font-weight: 600;cursor: pointer;transition: all 0.3s;  `;
  
  button.onmouseover = () => {
    button.style.background = '#218838';
    button.style.transform = 'translateY(-2px)';
    button.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
  };
  
  button.onmouseout = () => {
    button.style.background = '#28a745';
    button.style.transform = 'translateY(0)';
  };
  
  button.onclick = () => {
    sessionStorage.removeItem('return_to_product');
    sessionStorage.removeItem('captcha_challenge_detected');
    
    showCloudflareNotification('✅ Verification complete! Redirecting...', 'success');
    
    setTimeout(() => {
      window.location.href = returnUrl;
    }, 1000);
  };
  
  container.appendChild(button);
  document.body.appendChild(container);
}

function showCloudflareNotification(message, type = 'info') {
  const oldNotif = document.querySelector('[data-cloudflare-notification]');
  if (oldNotif) oldNotif.remove();
  
  const notification = document.createElement('div');
  notification.setAttribute('data-cloudflare-notification', 'true');
  notification.style.cssText = `position: fixed;top: 20px;right: 20px;padding: 15px 20px;border-radius: 6px;z-index: 99998;font-size: 14px;font-weight: 500;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);max-width: 350px;word-wrap: break-word;  `;
  
  if (type === 'warning') {
    notification.style.background = '#fff3cd';
    notification.style.color = '#856404';
    notification.style.border = '1px solid #ffc107';
  } else if (type === 'success') {
    notification.style.background = '#d4edda';
    notification.style.color = '#155724';
    notification.style.border = '1px solid #28a745';
  }
  
  notification.textContent = message;
  document.body.appendChild(notification);
  
  setTimeout(() => {
    notification.style.transition = 'opacity 0.3s ease';
    notification.style.opacity = '0';
    setTimeout(() => notification.remove(), 300);
  }, 5000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(handleCartPageAfterCaptcha, 1000);
  });
} else {
  handleCartPageAfterCaptcha();
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    setTimeout(handleCartPageAfterCaptcha, 500);
  }
}); 